import {
  getFormattedDateTime,
  rrcDistrictCodes,
  rrcAutoSignStrategies,
} from '@ots-frontend/ots-data';
export const rrcProfileOptions = () => ({
  districts: rrcDistrictCodes.map((code) => ({
    value: code.code,
    label: code.displayValue.defaultMessage ?? code.code,
  })),
  strategies: rrcAutoSignStrategies.map((code) => ({
    value: code.code,
    label: code.displayValue.defaultMessage ?? code.code,
  })),
});
export const rrcProfileCodeLabel = (value?: string) => {
  if (!value) return 'Not configured';
  const options = rrcProfileOptions();
  return (
    [...options.districts, ...options.strategies].find(
      (option) => option.value === value
    )?.label ?? value
  );
};
export const rrcProfileDate = (value?: number, empty = 'No end date') =>
  value == null ? empty : getFormattedDateTime(value);
